<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES94UC2']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['160'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.desc_codinput }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['20'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.desc_codempid }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['30'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ setDateOutput(detail.tab1.dtereq) }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['40'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ setYearOutput(detail.tab1.dteyear) }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['50'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.numclseq }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['60'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.codcours }} - {{ detail.tab1.desc_codcours }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['70'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ setDateOutput(detail.tab1.dtetrst) }} - {{ setDateOutput(detail.tab1.dtetren) }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['80'] }}</label>
                  <div class="col-md-4">
                    <div class="input-group margin-b-0">
                        <input class="form-control" readonly v-model="detail.tab1.qtytrmin" />
                        <div class="input-group-addon">{{ labels['HRES94UC2']['90'] }}</div>
                      </div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['100'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.desc_codinsts }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['110'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.desc_codhotel }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['120'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.desc_codinst }}</div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['130'] }}</label>
                  <div class="col-md-4">
                    <div class="input-group margin-b-0">
                        <input class="form-control" readonly v-model="detail.tab1.amtemp" />
                        <div class="input-group-addon">{{ labels['HRES94UC2']['140'] }}</div>
                      </div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal">
                <div class="form-group margin-b-5">
                  <label class="col-md-4 control-label">{{ labels['HRES94UC2']['150'] }}</label>
                  <div class="col-md-4">
                    <div class="form-control readonly-field-color">{{ detail.tab1.desreq }}</div>
                  </div>
                </div>
              </form>          
            </div>
          </div>
        </div>
      </div>
    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hres94u-detail',
  props: [ 'labels', 'detail', 'toggle', 'data', 'labelsButton' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    },
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?3169e122